export default "__VITE_ASSET__4eXIrT3q__"